import React, { Fragment, lazy, Suspense, useEffect, useRef } from 'react';
import { translate } from '../Services/translation';
import { useSelector } from 'react-redux';
import AsideContent from './AsideContent';

const MiniCartProducts = lazy(() => import('./MiniCartProducts'));

const MiniCart = () => {
    const toggleRef = useRef(null);
    const { orderRows, orderTotal, quantity, checkoutUrl, deliveryCost, discount, miniCartOpenCount } = useSelector((state) => state.cart);
    const onToggle = () => { toggleRef.current.toggleAside(); };

    useEffect(() => {
        if (miniCartOpenCount) {
            toggleRef.current.open();
        }
    }, [miniCartOpenCount]);

    return (
        <Fragment>
            <div className="cart cart--mini">
                <a
                    className={"cart__link--block"}
                    rel="nofollow"
                    title={translate('minicart.checkout')}
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        onToggle();
                    }}
                >
                    <i className="cart__icon">
                        <span className="cart__quantity">{quantity}</span>
                    </i>
                    <span className="cart__title">
                        {translate('minicart.checkout')}
                    </span>
                </a>
            </div>
            <AsideContent ref={toggleRef} cssClass="mini-cart-aside" title={translate('code.minicart.heading')}>
                <div className="mini-cart">
                    {orderRows.length ? (
                        <Fragment>
                            <div className="mini-cart__product">
                                {orderRows.map((orderRow) => {
                                    return (
                                        <Suspense key={orderRow.rowSystemId} fallback={null}>
                                            <MiniCartProducts orderRow={orderRow} />
                                        </Suspense>
                                    );
                                })}
                            </div>
                            <div className="mini-cart__summary">
                                {discount && (
                                    <div className="mini-cart__summary__row">
                                        <span>{translate('code.minicart.discount')}</span>
                                        <span>{discount}</span>
                                    </div>
                                )}
                                <div className="mini-cart__summary__row">
                                    <span className="mini-cart__summary__row__total">{translate('code.minicart.totalincvat')}</span>
                                    <span className="mini-cart__summary__row__total">{orderTotal}</span>
                                </div>
                            </div>
                            <div className="mini-cart__button">
                                <a href={checkoutUrl} className="mini-cart__button--checkout">
                                    {translate('code.minicart.tocheckout')}
                                </a>
                                <button onClick={() => onToggle()} className="mini-cart__button--back">
                                    {translate('code.minicart.back')}
                                </button>
                            </div>
                            
                        </Fragment>
                    ) : (
                        <h2>{translate('code.minicart.emptyheading')}</h2>
                    )}
                </div>
            </AsideContent>
        </Fragment>
    );
};

export default MiniCart;